'use es6';

import { createSelector } from 'reselect';
import { getAllLayoutSectionTreesAsMap, getLayoutSectionTreeById, getAllGridLayoutTreesAsMap } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { forEachTree, getLayoutIteratorForTree } from 'layout-dnd-utils/layoutTreeIterators';
import { getGridLayoutDataTreeIterator } from 'layout-data-lib/GridLayoutDataTree/utils';
export const getLayoutIteratorMap = createSelector([getAllLayoutSectionTreesAsMap], allLayoutSectionTrees => {
  const layoutIteratorMap = {};
  forEachTree(allLayoutSectionTrees, (tree, key) => {
    layoutIteratorMap[key] = getLayoutIteratorForTree(tree);
  });
  return layoutIteratorMap;
});
export const makeGetLayoutSectionEmptyCells = () => {
  return createSelector(getLayoutSectionTreeById, tree => {
    return tree.allCells().filter(cell => {
      return !cell.isModule() && !cell.hasRows();
    });
  });
};
export const makeGetLayoutSectionEmptyRows = () => {
  return createSelector(getLayoutSectionTreeById, tree => {
    return tree.allRows().filter(cell => {
      return !cell.hasColumns();
    });
  });
};
export const getGridLayoutIteratorMap = createSelector([getAllGridLayoutTreesAsMap.ungated], gridLayouts => {
  const gridLayoutIteratorMap = {};
  forEachTree(gridLayouts, tree => {
    gridLayoutIteratorMap[tree.getRootId()] = getGridLayoutDataTreeIterator(tree);
  });
  return gridLayoutIteratorMap;
});